<template>
  <div
    class="relative text-center"
    :class="{ 'z-10': !isActive, 'z-20': isActive }"
  >
    <a
      class="inline-flex relative z-20 p-6"
      :href="item.itemLink"
      target="_blank"
      @mousemove="handleMouseover"
      @mouseenter="isActive = true"
      @mouseleave="isActive = false"
    >
      <div
        :class="{ underline: !isActive }"
        class="relative text-xl leading-none"
      >
        {{ item.itemHeading }}
      </div>
      <transition name="fade">
        <div
          v-if="item.itemSubHeading && isActive"
          class="absolute bottom-0 inset-x-0 text-center text-sm -mb-1 pointer-events-none"
        >
          {{ item.itemSubHeading }}
        </div>
      </transition>
    </a>
    <transition name="fade">
      <div
        v-if="isActive"
        class="absolute z-10"
        :style="{
          width: `40vw`,
          left: `50%`,
          top: `50%`,
          transform: `translate3d(calc(-50% + ${x}),calc(-50% + ${y}),0)`,
        }"
      >
        <img :src="item.itemImage[0].url" :alt="item.itemImage[0].title" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FlexibleContentRichPartners",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isActive: false,
      x: "0px",
      y: "0px",
    };
  },
  methods: {
    handleMouseover(event) {
      var rect = event.target.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      this.x = `${x - rect.width / 2}px`;
      this.y = `${y - rect.height / 2}px`;
    },
  },
};
</script>
